<span
  bbTooltip="Cancelling this payment cannot be undone!"
  placement="bottom"
>
  <bb-icon-ui name="info" color="info" size="lg"></bb-icon-ui>
</span>
